import React from 'react';
import { routes as r } from '../../../routes';
import { SchedulerShiftsCalendar } from '../SchedulerShiftsCalendar';
import { SentShiftChangeRequests } from '../SentShiftChangeRequests';
import { ReceivedShiftChangeRequests } from '../ReceivedShiftChangeRequests';

export const routes = () => ({
  schedulerShiftsCalendar: {
    route: r.schedulerShifts.route,
    render: () => <SchedulerShiftsCalendar />,
  },
  sentChangeRequests: {
    route: r.schedulerShiftsSentTransferRequests.route,
    render: () => <SentShiftChangeRequests />,
  },
  receivedChangeRequests: {
    route: r.schedulerShiftsReceivedTransferRequests.route,
    render: () => <ReceivedShiftChangeRequests />,
  },
});
